import React from "react";
import styled from "styled-components";
import logo from "../images/c-logo.svg";

const Wrapper = styled.footer`
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
  align-items: flex-start;
  background-color: ${props => props.theme.colors.black};
  position: relative;
`;

const List = styled.ul`
  margin: 0 auto;
  max-width: 1200px;
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 3.15rem 0;
`;

const Item = styled.li`
  display: inline-block;
  padding: 0 1rem;
  width: 100%;
  @media screen and (min-width: ${props => props.theme.responsive.small}) {
    width: auto;
    min-width: 254px;
    
    &:last-child {
      a {
        float: right;
      }
    }
  }
  
  @media screen and (max-width: ${props => props.theme.responsive.small}) {
    &:not(:last-child) {
      margin-bottom: 3em;
    }
  }
  
  a {
    text-decoration: none;
    color: #ffffff;
    
    &:focus,
    &:hover {
      text-decoration: underline;
    }
  }
`;

const Wordmark = styled.img`
  max-width: 100px;
`;

const Logo = styled.img``;

const Footer = () => (
  <Wrapper>
    <List>
      <Item>
        <a href="/disclaimer">Privacy Statement & Disclaimer</a>
      </Item>
      <Item>
        <Logo src={logo} alt="Huvaros" />
      </Item>
      <Item>
        <a href="https://www.contentful.com/" rel="nofollow" target="_blank">
          <Wordmark
            src="https://images.ctfassets.net/fo9twyrwpveg/7Htleo27dKYua8gio8UEUy/0797152a2d2f8e41db49ecbf1ccffdaa/PoweredByContentful_DarkBackground_MonochromeLogo.svg"
            alt="Powered by Contentful"
          />
        </a>
      </Item>
    </List>
  </Wrapper>
);

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer.js